import {
  BLACK,
  BLUE,
  GREEN,
  GREY,
  RED,
  YELLOW,
  WHITE
} from 'src/constants/colors'
import {
  EXTRA_SMALL_SPACING,
  SMALL_SPACING,
  MEDIUM_SPACING,
  LARGE_SPACING,
  EXTRA_LARGE_SPACING,
  LAYOUT_SPACING_DESKTOP,
  LAYOUT_SPACING_MOBILE
} from 'src/constants/spacing'

// root theme: define function level & component level colors
const rootTheme = {
  spacing: {
    xs: EXTRA_SMALL_SPACING,
    sm: SMALL_SPACING,
    md: MEDIUM_SPACING,
    lg: LARGE_SPACING,
    xl: EXTRA_LARGE_SPACING
  },
  layout: {
    desktop: LAYOUT_SPACING_DESKTOP,
    mobile: LAYOUT_SPACING_MOBILE
  },
  text: {
    default: BLACK.DEFAULT,
    white: WHITE.DEFAULT
  },
  button: {
    background: WHITE.DEFAULT,
    color: BLACK.DEFAULT,
    border: GREY.S200,
    hover: BLACK.T10
  },
  actionButton: {
    color: GREY.S400,
    hover: GREY.T10
  },
  neutral: {
    text: GREY.S400,
    emphasis: GREY.S300,
    border: GREY.S200,
    background: GREY.S100,
    white: WHITE.DEFAULT,
    bluish: GREY.BLUISH
  },
  success: {
    text: GREEN.S400,
    emphasis: GREEN.S300,
    border: GREEN.S300,
    background: GREEN.S100
  },
  warning: {
    text: YELLOW.S400,
    emphasis: YELLOW.S300,
    border: YELLOW.S300,
    background: YELLOW.S100
  },
  error: {
    text: RED.S400,
    emphasis: RED.S300,
    border: RED.S300,
    background: RED.S100
  },
  card: {
    background: {
      default: WHITE.DEFAULT,
      dark: BLACK.T10
    }
  },
  divider: {
    background: GREY.S200
  }
}

// define brand level colors
export const xfersTheme = {
  ...rootTheme,
  brand: {
    primary: {
      default: BLUE.DEFAULT,
      emphasis: BLUE.S300,
      background: BLUE.S100,
      contrast: WHITE.DEFAULT
    },
    action: {
      default: BLUE.DEFAULT,
      hover: BLUE.T10,
      disabledOpacity: 0.7
    }
  }
}
